import { cleanNonSessionProfileState } from './profile';
import { history } from './rewards';
import { 
  communicationPreferencesState, 
  communicationPreferences, 
  hydrateUiProfileCommunicationPreferencesState,
  updateSubscriptions
} from './communicationPreferences';


// the following is imported in actions/index.js as "profile"
export default {
  cleanNonSessionProfileState,
  history,
  hydrateUiProfileCommunicationPreferencesState,
  communicationPreferencesState,
  communicationPreferences,
  updateSubscriptions
};
